import {networkError} from "./ui";
import * as R from 'ramda';

import {clearSubview, clearView, injectSubview, injectView, setView, setViewPath} from "./view";
import {
  addUserContactListEmails$,
  addUserContactListUser$,
  createUserContactList$,
  deleteUserContactList$,
  deleteUserContactListUser$,
  getUserContactListById$,
  getUserContactLists$,
  getUserContactListUsers$,
  updateUserContactList$
} from "../services/users";
import {currentEffectiveUserId} from "../reducers/ui";

export const getContactListDone = (response, callback) => async (dispatch, getState) => {
  callback && callback(response.id);
  dispatch(setView(R.unnest(response)));
};

export const getContactListsDone = (response) => async (dispatch, getState) => {
  dispatch(injectView(R.unnest(response)));
};

export const getContactListUsersDone = (response) => async (dispatch, getState) => {
  response.forEach(result => result.id = result.contactuserid);
  dispatch(injectSubview(response));
};

export const getContactList = ({ id }) => async (dispatch, getState) => {
  dispatch(setViewPath(['settings', 'contact-lists', id]));
  dispatch(getContactLists({ id }));
  dispatch(getContactListUsers({ listId: id }));
};

export const getContactLists = ({ id } = {}) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    const userId = currentEffectiveUserId(getState());
    dispatch(clearView());
    do {
      let { response, status: response_status } = await getUserContactLists$({ userId, offset: nextOffset, id }).toPromise();
      if (!response || response_status === 204) return;
      const { results, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(getContactListsDone(results));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10041-'+error.status}));
  }
};

export const getContactListUsers = ({ listId, id } = {}) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    const userId = currentEffectiveUserId(getState());
    dispatch(clearSubview());
    do {
      let { response, status: response_status } = await getUserContactListUsers$({ userId, contactListId: listId, offset: nextOffset, id }).toPromise();
      if (!response || response_status === 204) return;
      const { results, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(getContactListUsersDone(results));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10042-'+error.status}));
  }
};

export const createContactList = (name, description, callback) => async (dispatch, getState) => {
  try {
    const userId = currentEffectiveUserId(getState());
    let { response, status } = await createUserContactList$({ userId, name, description }).toPromise();
    ({ response, status } = await getUserContactListById$({ userId, contactListId: response }).toPromise());
    dispatch(getContactListDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10043-'+error.status}));
  }
};

export const addUserToContactList = (userId, contactListId, contactId, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await addUserContactListUser$({ userId, contactListId, contactId }).toPromise();
    dispatch(getContactListUsers({ userId, listId: contactListId }));
    callback && callback();
  } catch (error) {
    dispatch(networkError({...error, number: '10044-'+error.status}));
  }
};

export const addEmailsToContactList = (userId, contactListId, emails, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await addUserContactListEmails$({ userId, contactListId, addresses: emails }).toPromise();
    dispatch(getContactListUsers({ userId, listId: contactListId }));
    callback && callback();
  } catch (error) {
    dispatch(networkError({...error, number: '10045-'+error.status}));
  }
};

export const removeUserFromContactList = (contactListId, contactId) => async (dispatch, getState) => {
  try {
    const userId = currentEffectiveUserId(getState());
    let { response, status } = await deleteUserContactListUser$({ contactListId, userId, contactId }).toPromise();
    dispatch(getContactListUsers({ userId, listId: contactListId }));
  } catch (error) {
    dispatch(networkError({...error, number: '10046-'+error.status}));
  }
};

export const updateContactListDetails = (contactListId, name, description) => async (dispatch, getState) => {
  try {
    const userId = currentEffectiveUserId(getState());
    let details = {
      name,
      description
    };
    let { response, status } = await updateUserContactList$({ userId, contactListId, details }).toPromise();
    dispatch(getContactLists());
  } catch (error) {
    dispatch(networkError({...error, number: '10047-'+error.status}));
  }
};

export const deleteContactList = (contactListId) => async (dispatch, getState) => {
  try {
    const userId = currentEffectiveUserId(getState());
    let { response, status } = await deleteUserContactList$({ userId, contactListId }).toPromise();
    dispatch(getContactLists());
  } catch (error) {
    dispatch(networkError({...error, number: '10048-'+error.status}));
  }
};




// WEBPACK FOOTER //
// ./src/actions/contactlists.js